<template>
  <div class="redirect-main">
    <div class="redirect-container">
      <div class="logo-border px-4 py-4">
        <div class="d-flex justify-center">
          <img src="/iba-logo-slogan-white.png" width="150" height="100" alt="IBA Logo" />
        </div>
        <div class="text-center my-8 mx-0 title-section">
          <div class="my-8 headline"><b>🚧 Under Construction 🚧</b></div>
          <p>We’re taking a quick break (about 48 hours) to roll out our new website!</p>
          <p>✨ A fresh look, smoother navigation, and exciting new features are on the way.</p>
          <p>✉️ We’ve sent out the details to all members — check your email for the scoop.</p>
        </div>
      </div>

      <div class="info-wrapper">
        <div class="info-content">
          <div class="main-message">
            We're giving the site a great big makeover.
          </div>
          <div>
            <div class="sub-message mb-6">
              Come back later for our big reveal. We promise, it'll be worth it.
            </div>
            <div>
              <div><b>In the meantime, reach us at:</b></div>
              <div class="contact">
                <a href="mailto:office@bodytalksystem.com" style="color:white; text-decoration:none">
                  office@bodytalksystem.com
                </a> or +1 941-921-7443
              </div>
            </div>
          </div>
          <div class="d-flex social-icons">
            <!-- Instagram -->
            <a href="https://www.instagram.com/bodytalksystem/" target="_blank" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" width="28" height="28">
                <rect width="18" height="18" x="3" y="3" rx="5" ry="5" stroke-width="1.5" />
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" stroke-width="1.5" />
                <path d="M17.5 6.5h.01" stroke-width="2" stroke-linecap="round" />
              </svg>
            </a>

            <!-- Facebook -->
            <a href="https://www.facebook.com/thebodytalksystem" target="_blank" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white" width="28" height="28">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M18 2h-3a4 4 0 00-4 4v3H8v4h3v9h4v-9h3l1-4h-4V6a1 1 0 011-1h3V2z" />
              </svg>
            </a>

            <!-- Twitter -->
            <a class="mx-3" href="https://x.com/BodyTalkSystem" target="_blank" aria-label="Twitter">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1227" fill="none" stroke="white" width="28" height="28">
                <path fill="white"
                  d="M725 546l264-339h-62L695 510 507 207H263l282 431-282 360h62l244-311 211 311h243L725 546zm-86 109l-30-43-222-321h108l172 249 29 42 237 344H819l-180-271z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
};
</script>

<style scoped>
.redirect-main {
  color: white;
  min-height: 100vh;
  background-color: rgb(9 38 67);
  padding: 50px;
}

.redirect-container {
  max-width: 80%;
  background-color: #0071bd;
  margin: auto;
  padding: 40px 0;
}

.logo-border {
  border-bottom: 2px solid white;
}

.title-section {
  font-size: 26px;
}

.headline {
  font-size: 40px !important;
}

.info-wrapper {
  padding: 3rem 4rem;
}

.info-content {
  display: flex;
  gap: 40px;
  margin: auto;
}
@media (max-width: 1400px) {
  .info-content {
    gap: 30px;
  }
  .info-wrapper {
    padding: 3rem 3rem;
  }
}
@media (max-width: 1200px) {
  .info-content {
    flex-direction: column;
  }
}
@media (max-width: 1024px) {
  .redirect-main {
    padding: 40px 20px;
  }
  .redirect-container {
    max-width: 90%;
  }
  .info-wrapper {
    padding: 3rem;
  }
}
@media (max-width: 768px) {
  .redirect-main {
    padding: 30px 30px;
  }
  .redirect-container {
    max-width: 100%;
  }
  .info-wrapper {
    padding: 2rem;
  }
}

.main-message {
  font-size: 42px;
  line-height: 50px;
}

.sub-message {
  font-size: 30px;
  line-height: 37px;
}

.contact {
  font-size: 20px;
}

.social-icons {
  align-self: end;
  display: flex;
  gap: 12px;
  margin-top: 1rem;
}
</style>
